import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconPeople: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="people, user, person, avatar"><path d="M15.75 6.5C15.75 8.57107 14.0711 10.25 12 10.25C9.92893 10.25 8.25 8.57107 8.25 6.5C8.25 4.42893 9.92893 2.75 12 2.75C14.0711 2.75 15.75 4.42893 15.75 6.5Z" stroke="currentColor" strokeWidth="1.5" strokeLinejoin="round"/><path d="M12 13.25C7.8098 13.25 4.86894 16.3254 4.5 20.25H19.5C19.1311 16.3254 16.1902 13.25 12 13.25Z" stroke="currentColor" strokeWidth="1.5"/></CentralIconBase>;
};

export default IconPeople;
